import { render, staticRenderFns } from "./o-sorting-panel.vue?vue&type=template&id=190172ca&"
import script from "./o-sorting-panel.vue?vue&type=script&lang=js&"
export * from "./o-sorting-panel.vue?vue&type=script&lang=js&"
import style0 from "./o-sorting-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports